module.exports = __webpack_public_path__ + "static/media/about_us_alarm.bd208b16.svg";